import * as React from "react";
import { Modal, Fade, Card, Grid, Icon, InputLabel } from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

//Context
import { useContext } from "react";
import { MessageManager } from "context";
import colors from "assets/theme/base/colors";
import SoftInput from "components/SoftInput";
import { useRef } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { urlBase } from "services/config";
import axios from "axios";
import { green } from "@mui/material/colors";
import { agregarCeros } from "utils/truncate";
import { useEffect } from "react";

const { inputColors } = colors;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "60%", md: "60%" },
  py: 4,
};
const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;
const invalidKeysInputNumber = ["e", ".", "-", "+"];

export default function ModalNuevoProducto({ open, handleClose, agregarNuevoProducto, remito }) {
  const { handleSnackbar } = useContext(MessageManager);
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const [inputCambiado, setInputCambiado] = useState(false);
  const [nuevoProducto, setNuevoProducto] = useState({
    cantidad: "",
    codigo: "",
  });
  const [listadoProductos, setListadoProductos] = useState([]);
  const [selected, setSelected] = useState(0);
  const [loading, setLoading] = useState(false);
  const handleChangeNuevoProducto = (e) => {
    setNuevoProducto({ ...nuevoProducto, [e.target.name]: e.target.value });
  };

  const inputCodigoRef = useRef(null);
  const inputCantidadRef = useRef(null);
  const itemRefs = useRef([]);

  const handleAddProducto = () => {
    const date = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    if (listadoProductos.length > 0) {
      agregarNuevoProducto({
        ...listadoProductos[selected],
        idEncabezado: remito.id,
        Cantidad: nuevoProducto.cantidad,
        Descripcion: listadoProductos[selected].Nombre,
        fecha: date,
        remito_id: remito.id,
        ID: agregarCeros(remito.codigoSucursal, 4) + remito.numero,
        TipoMovimientoRemito: "Recepción",
        Fecha: date,
        Estado: "finalizado",
        Movimiento: "Remito Interno",
        Agregado: true,
      });
      setNuevoProducto({
        cantidad: "",
        codigo: "",
      });
      setListadoProductos([]);
      handleClose();
      // inputCantidadRef.current.focus();
    }
  };

  const searchProducto = useCallback(async (codigo) => {
    setLoading(true);
    setInputCambiado(false);
    try {
      const response = await axios.get(urlBase + `materialesSearch/${codigo}`);
      setListadoProductos(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (open && inputCodigoRef.current) {
      inputCodigoRef.current.focus();
    }
    if (!open) {
      setListadoProductos([]);
      setNuevoProducto({
        cantidad: "",
        codigo: "",
      });
      setSelected(0);
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={(event, reason) => {
        if (reason === "escapeKeyDown") {
          handleClose();
        }
      }}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox px={3} display={"flex"} justifyContent="space-between" alignItems="end">
            <SoftTypography variant="h6">Agregar producto a remito</SoftTypography>
            <SoftButton
              variant="text"
              color="dark"
              size="medium"
              onClick={() => {
                handleClose();
              }}
            >
              Cerrar
              <Icon
                sx={{
                  ml: 1.5,
                }}
              >
                close
              </Icon>
            </SoftButton>
          </SoftBox>
          <Grid container p={3}>
            <Grid item xs={12} spacing={2} container>
              {/* <Grid item xs={12} md={3}>
                <InputLabel>
                  <SoftTypography variant="subtitle2" fontWeight="bold">
                    Cantidad
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  placeholder="Cantidad"
                  type="number"
                  name="cantidad"
                  value={nuevoProducto.cantidad}
                  inputRef={inputCantidadRef}
                  onChange={handleChangeNuevoProducto}
                  onKeyDown={(e) => {
                    if (invalidKeysInputNumber.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && nuevoProducto.cantidad) {
                      inputCodigoRef.current.focus();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                  }}
                />
              </Grid> */}
              <Grid item xs={12} md={12}>
                <InputLabel>
                  <SoftTypography variant="subtitle2" fontWeight="bold">
                    Código barra producto
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  inputRef={inputCodigoRef}
                  placeholder="Buscar..."
                  onChange={(e) => {
                    setInputCambiado(true);
                    handleChangeNuevoProducto(e);
                  }}
                  value={nuevoProducto.codigo}
                  name="codigo"
                  onKeyDown={(e) => {
                    if (e.key === "ArrowDown") {
                      setSelected((prev) => (prev < listadoProductos.length - 1 ? prev + 1 : 0));
                    } else if (e.key === "ArrowUp") {
                      setSelected((prev) => (prev > 0 ? prev - 1 : listadoProductos.length - 1));
                    } else if (e.key === "Enter" && e.target.value && inputCambiado) {
                      searchProducto(e.target.value);
                    }
                    // else if (e.key === "Enter" && e.target.value && !inputCambiado) {
                    //   handleAddProducto();
                    // }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel>
                  <SoftTypography variant="subtitle2" fontWeight="bold">
                    Productos encontrados
                  </SoftTypography>
                </InputLabel>
                <Grid container pr={1} mt={1}>
                  <Grid item xs={2} display="flex" justifyContent="center">
                    <SoftTypography variant="subtitle2" fontWeight="bold">
                      Cod. Prov.
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6} display="flex" justifyContent="flex-start">
                    <SoftTypography variant="subtitle2" fontWeight="bold">
                      Nombre
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={2} display="flex" justifyContent="center">
                    <SoftTypography variant="subtitle2" fontWeight="bold">
                      Talle
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={2} display="flex" justifyContent="center">
                    <SoftTypography variant="subtitle2" fontWeight="bold">
                      Color
                    </SoftTypography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  py={2}
                  my={1}
                  sx={{
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 2,
                    maxHeight: 150,
                    overflowY: "auto",
                  }}
                >
                  {loading ? (
                    <Grid item xs={12} display="flex" justifyContent="center" py={4}>
                      <SoftTypography variant="body2">Cargando...</SoftTypography>
                    </Grid>
                  ) : listadoProductos.length > 0 ? (
                    listadoProductos.map((producto, index) => (
                      <Grid
                        item
                        xs={12}
                        key={producto.id}
                        px={2}
                        m={0.2}
                        ref={(el) => (itemRefs.current[index] = el)}
                        display="flex"
                        justifyContent="space-between"
                        sx={{
                          backgroundColor: selected === index ? green[100] : "transparent",
                          borderRadius: 2,
                        }}
                      >
                        <Grid item xs={2} display="flex" justifyContent="center">
                          <SoftTypography variant="subtitle2" color="black">
                            {producto.CodProv}
                          </SoftTypography>
                        </Grid>
                        <Grid item xs={6} display="flex" justifyContent="flex-start">
                          <SoftTypography variant="subtitle2" color="black">
                            {producto.Nombre}
                          </SoftTypography>
                        </Grid>
                        <Grid item xs={2} display="flex" justifyContent="center">
                          <SoftTypography variant="subtitle2" color="black">
                            {producto.TALLE}
                          </SoftTypography>
                        </Grid>
                        <Grid item xs={2} display="flex" justifyContent="center">
                          <SoftTypography variant="subtitle2" color="black">
                            {producto.COLOR}
                          </SoftTypography>
                        </Grid>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12} display="flex" justifyContent="center" py={4}></Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <SoftBox display="flex" justifyContent="flex-end" alignItems="center" px={3} pt={3}>
            <SoftBox>
              <SoftButton
                variant="gradient"
                size="large"
                color="dark"
                onClick={() => {
                  handleAddProducto();
                }}
                disabled={listadoProductos.length === 0}
              >
                <>
                  <Icon
                    sx={{
                      mr: 0.4,
                    }}
                  >
                    add
                  </Icon>
                  Agregar
                </>
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalNuevoProducto.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  agregarNuevoProducto: PropTypes.func,
  remito: PropTypes.object,
};
